import keyBy from 'lodash.keyby'


export const langs = [
	{ key: 'en', label: '🇬🇧', text: 'English' },
	{ key: 'ru', label: '🇷🇺', text: 'Русский' }
].map(l => ({ ...l, labeled_text: `${l.label} ${l.text}` }))

export const langsByKey = keyBy(langs, 'key')
